// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"795":"35034e19","895":"35034e19"}[chunkId] + ".css";
};